export const CRM_SHAREABLE = 'CRM_SHAREABLE'
export const CRM_SHARE_AVAIL = 'CRM_SHARE_AVAIL'
export const CRM_CONTACT_CARD = 'CRM_CONTACT_CARD'
export const CRM_CONTACT_PAGE = 'CRM_CONTACT_PAGE'
export const CRM_INTERACTIONS_FEED = 'CRM_INTERACTIONS_FEED'

export const CRM_SHAREABLE_SOURCES = [
  CRM_SHAREABLE,
  CRM_SHARE_AVAIL,
  CRM_CONTACT_CARD,
  CRM_CONTACT_PAGE,
  CRM_INTERACTIONS_FEED,
]
